/**
 * KN Custom — Product Drop, Sold-out Notify, Drop Badges
 * ------------------------------------------------------
 * 1. Locks the checkout button until the drop launch time, then
 *    auto-unlocks client-side to the second.
 * 2. Turns sold-out size pills into a "notify me" trigger that opens
 *    the REZ Preorder / Notify Me popup.
 * 3. Drives the drop badges (pre-launch label -> "New" window -> hidden)
 *    on product pages, product cards and the cart.
 */

(function () {

// Verbose logging — flip to false to silence. Left on so the
// behaviour is easy to verify from the browser console.
var KN_DEBUG = false;

function knLog() {
  if (!KN_DEBUG) return;
  var args = Array.prototype.slice.call(arguments);
  args.unshift('[KN]');
  console.log.apply(console, args);
}

var KN_BADGE_HIDE_ELAPSED = true;

// Post-launch "New" badge window (shared by product, card and cart badges).
var KN_NEW_ENABLED = true;
var KN_NEW_LABEL = "New";
var KN_NEW_HOURS = 48;

// ------------------------------------------------------------------
// REZ Preorder / Notify Me integration
//
// The REZ app injects its "Alert me when Restocked!" button via an
// app embed, so there is no fixed selector in the theme. We look for
// it by a list of likely selectors first, then fall back to matching
// button/link text. If the app changes its markup, just update
// KN_REZ.selectors or KN_REZ.textMatch below.
// ------------------------------------------------------------------

var KN_REZ = {
  // REZ injects button.rez-stock-notification-button via app embed.
  selectors: [
    'button.rez-stock-notification-button',
    '.rez-stock-notification-button'
  ],
  // Fallback if the app renames its class.
  textMatch: /alert me when restock/i,
  retries: 8,
  retryDelay: 150
};

function isVisible(el) {
  if (!el) return false;
  if (el.offsetParent === null && getComputedStyle(el).position !== 'fixed') return false;
  var rect = el.getBoundingClientRect();
  return rect.width > 0 && rect.height > 0;
}

function findRezNotifyTrigger() {
  for (var i = 0; i < KN_REZ.selectors.length; i++) {
    var nodes = document.querySelectorAll(KN_REZ.selectors[i]);
    for (var j = 0; j < nodes.length; j++) {
      if (isVisible(nodes[j])) {
        knLog('REZ trigger via selector', KN_REZ.selectors[i], nodes[j]);
        return nodes[j];
      }
    }
  }

  var clickable = document.querySelectorAll('button, a, [role="button"]');
  for (var k = 0; k < clickable.length; k++) {
    var el = clickable[k];
    if (el.closest('.kn-cart-drop-notice, .kn-product-drop-notice')) continue;
    var text = (el.textContent || '').trim();
    if (text && KN_REZ.textMatch.test(text) && isVisible(el)) {
      knLog('REZ trigger via text match', text, el);
      return el;
    }
  }

  knLog('REZ trigger not found');
  return null;
}

// Try to click the REZ trigger, retrying while the app re-renders.
function triggerRezNotify(attempt) {
  attempt = attempt || 0;
  var trigger = findRezNotifyTrigger();
  if (trigger) {
    trigger.click();
    knLog('REZ trigger clicked');
    return;
  }
  if (attempt < KN_REZ.retries) {
    setTimeout(function () { triggerRezNotify(attempt + 1); }, KN_REZ.retryDelay);
  }
}

// ------------------------------------------------------------------
// Sold-out size pills -> REZ notify
//
// Clicking a sold-out pill still selects that variant (so REZ scopes
// its form to the right size), then opens the notify popup.
// ------------------------------------------------------------------

var soldOutPillsInstalled = false;

function initSoldOutPillNotify() {
  if (soldOutPillsInstalled) return;
  soldOutPillsInstalled = true;

  document.addEventListener('click', function (e) {
    var pill = e.target.closest ? e.target.closest('.pill[no-available]') : null;
    if (!pill) return;
    knLog('Sold-out pill clicked — opening notify');
    // Let the theme select the variant first, then nudge REZ.
    requestAnimationFrame(function () {
      setTimeout(function () { triggerRezNotify(0); }, KN_REZ.retryDelay);
    });
  });
}

// ------------------------------------------------------------------
// Countdown formatter
// ------------------------------------------------------------------

function formatCountdown(ms) {
  var s = Math.floor(ms / 1000);
  var d = Math.floor(s / 86400);
  var h = Math.floor((s % 86400) / 3600);
  var m = Math.floor((s % 3600) / 60);
  var sec = s % 60;

  var segs = [];
  if (d > 0) segs.push([d, 'days']);
  segs.push([h, 'hrs']);
  segs.push([m, 'min']);
  segs.push([sec, 'sec']);

  var parts = segs.map(function (seg) {
    var n = (seg[0] < 10 ? '0' : '') + seg[0];
    return '<span class="kn-cd-seg">' +
             '<span class="kn-cd-num">' + n + '</span>' +
             '<span class="kn-cd-lbl">' + seg[1] + '</span>' +
           '</span>';
  });
  return parts.join('<span class="kn-cd-sep">:</span>');
}

// ------------------------------------------------------------------
// Drop date formatter (used in notice label)
// ------------------------------------------------------------------

function formatDropDate(ts) {
  var d = new Date(ts);
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric' }) +
         ' at ' +
         d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' });
}

// ------------------------------------------------------------------
// Global drop time
//
// Scans ALL [data-kn-drop-time] elements in the DOM — cart items
// (cart-item.liquid, cart-notification-popup-content.liquid) and
// checkout buttons. AJAX-refreshed by bundle.js, always current.
// ------------------------------------------------------------------

function getGlobalDropTime() {
  var maxTime = 0;
  document.querySelectorAll('[data-kn-drop-time]').forEach(function (el) {
    var t = new Date(el.getAttribute('data-kn-drop-time')).getTime();
    if (!isNaN(t) && t > maxTime) maxTime = t;
  });
  return maxTime;
}

// ------------------------------------------------------------------
// Redo app helper
// ------------------------------------------------------------------

function setRedoToggle(btn, locked) {
  var parent = btn.parentElement;
  if (!parent) return;
  var redoEl = parent.querySelector('redo-shopify-toggle');
  if (!redoEl) return;
  if (locked) {
    redoEl.setAttribute('data-kn-hidden', 'true');
  } else {
    redoEl.removeAttribute('data-kn-hidden');
  }
}

// ------------------------------------------------------------------
// Inject a drop notice after a checkout button
//
// Clones the prototype from #kn-drop-template (theme.liquid).
// Returns the notice element; creates it if not already injected.
// ------------------------------------------------------------------

function injectNotice(btn) {
  if (btn._knNotice && btn._knNotice.parentElement) {
    return btn._knNotice;
  }

  var notice = null;
  var templateEl = document.getElementById('kn-drop-template');
  if (templateEl) {
    var proto = templateEl.querySelector('.kn-cart-drop-notice');
    if (proto) notice = proto.cloneNode(true);
  }

  if (!notice) {
    notice = document.createElement('div');
    notice.className = 'kn-cart-drop-notice';
    notice.innerHTML =
      '<span class="kn-cart-drop-label"></span>' +
      '<span class="kn-cart-drop-countdown"></span>';
  }

  // Insert after redo-shopify-toggle if it follows the button,
  // otherwise insert directly after the button.
  var insertRef = btn;
  var parent = btn.parentElement;
  if (parent) {
    var redoEl = parent.querySelector('redo-shopify-toggle');
    if (redoEl && (btn.compareDocumentPosition(redoEl) & Node.DOCUMENT_POSITION_FOLLOWING)) {
      insertRef = redoEl;
    }
  }

  insertRef.parentNode.insertBefore(notice, insertRef.nextSibling);
  btn._knNotice = notice;
  return notice;
}

// ------------------------------------------------------------------
// Lock a single checkout button
// ------------------------------------------------------------------

function lockButton(btn, dropTime, notice, countdownEl) {
  if (btn._knTimer) { clearInterval(btn._knTimer); btn._knTimer = null; }
  if (btn._knObserver) { btn._knObserver.disconnect(); btn._knObserver = null; }

  // Inject the formatted drop date into the label once (replaces  placeholder).
  var labelEl = notice ? notice.querySelector('.kn-cart-drop-label') : null;
  if (labelEl && !labelEl._knDateSet) {
    labelEl.textContent = labelEl.textContent.replace('[[date]]', formatDropDate(dropTime));
    labelEl._knDateSet = true;
  }

  function applyLock() {
    btn.disabled = true;
    btn.setAttribute('data-kn-locked', 'true');
    setRedoToggle(btn, true);
    if (notice) notice.style.display = 'block';
  }

  function applyUnlock() {
    btn.disabled = false;
    btn.removeAttribute('data-kn-locked');
    setRedoToggle(btn, false);
    if (btn._knTimer) { clearInterval(btn._knTimer); btn._knTimer = null; }
    if (btn._knObserver) { btn._knObserver.disconnect(); btn._knObserver = null; }
    if (notice) notice.style.display = 'none';
  }

  // MutationObserver: re-lock if bundle.js removes disabled.
  // Uses getGlobalDropTime() live so a removed drop item is caught.
  btn._knObserver = new MutationObserver(function () {
    if (!btn.disabled) {
      var currentDrop = getGlobalDropTime();
      if (currentDrop > 0 && Date.now() < currentDrop) {
        applyLock();
      } else {
        applyUnlock();
      }
    }
  });
  btn._knObserver.observe(btn, { attributes: true, attributeFilter: ['disabled'] });

  function tick() {
    var diff = dropTime - Date.now();
    if (diff <= 0) {
      applyUnlock();
    } else {
      applyLock();
      if (countdownEl) countdownEl.innerHTML = formatCountdown(diff);
    }
  }

  tick();
  btn._knTimer = setInterval(tick, 1000);
}

// ------------------------------------------------------------------
// Form submit intercept (capture phase)
// Final safety net against Redo app / race conditions.
// ------------------------------------------------------------------

var formInterceptInstalled = false;

function installFormIntercept() {
  if (formInterceptInstalled) return;
  formInterceptInstalled = true;

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (!form.querySelector('button[name="checkout"], input[name="checkout"]')) return;

    var dropTime = getGlobalDropTime();
    if (dropTime > 0 && Date.now() < dropTime) {
      e.preventDefault();
      e.stopImmediatePropagation();
    }
  }, true);
}

// ------------------------------------------------------------------
// Product page countdown notices
// ------------------------------------------------------------------

function initProductDropNotice() {
  document.querySelectorAll('.kn-product-drop-notice[data-kn-drop-time]').forEach(function (el) {
    var dropTime = new Date(el.getAttribute('data-kn-drop-time')).getTime();
    if (isNaN(dropTime)) return;

    if (dropTime <= Date.now()) {
      el.style.display = 'none';
      return;
    }

    if (el._knTimer) clearInterval(el._knTimer);
    var countdownEl = el.querySelector('.kn-countdown');

    function tick() {
      var d = dropTime - Date.now();
      if (d <= 0) {
        el.style.display = 'none';
        clearInterval(el._knTimer);
        return;
      }
      if (countdownEl) countdownEl.innerHTML = formatCountdown(d);
    }
    tick();
    el._knTimer = setInterval(tick, 1000);
  });
}

// ------------------------------------------------------------------
// Cart checkout button locking
// Handles buttons that already carry data-kn-drop-time.
// ------------------------------------------------------------------

function initCartDropLock() {
  document.querySelectorAll('button[data-kn-drop-time]').forEach(function (btn) {
    var dropTime = new Date(btn.getAttribute('data-kn-drop-time')).getTime();
    if (isNaN(dropTime)) return;

    if (dropTime <= Date.now()) {
      btn.disabled = false;
      btn.removeAttribute('data-kn-locked');
      setRedoToggle(btn, false);
      return;
    }

    var parent = btn.closest('cart-buttons-block') ||
                 btn.closest('cart-drawer-buttons-block') ||
                 btn.parentElement;
    var notice = parent ? parent.querySelector('.kn-cart-drop-notice') : null;
    // Popup buttons have no static notice — inject one dynamically.
    if (!notice) notice = injectNotice(btn);
    var countdownEl = notice ? notice.querySelector('.kn-cart-drop-countdown') : null;

    lockButton(btn, dropTime, notice, countdownEl);
  });

  if (document.querySelectorAll('button[data-kn-locked]').length) {
    startWatchdog();
  }
}

// ------------------------------------------------------------------
// Lock a checkout button that has NO data-kn-drop-time
// (cart notification popup — button comes from a <template> that
// may have been rendered before the drop item was in the cart)
// ------------------------------------------------------------------

function tryLockDynamicCheckoutButton(btn) {
  if (btn._knTimer) return;
  if (btn.getAttribute('data-kn-drop-time')) return;

  var dropTime = getGlobalDropTime();
  if (!dropTime || Date.now() >= dropTime) return;

  var notice = injectNotice(btn);
  var countdownEl = notice ? notice.querySelector('.kn-cart-drop-countdown') : null;
  lockButton(btn, dropTime, notice, countdownEl);
}

// ------------------------------------------------------------------
// DOM observer
// Catches checkout buttons and drop notices added after page load.
// ------------------------------------------------------------------

function installDOMObserver() {
  if (window._knDOMObserver) return;

  window._knDOMObserver = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;

        // New checkout button added (popup template instantiated)
        var candidates = [];
        if (node.matches && node.matches('button[name="checkout"]')) candidates.push(node);
        node.querySelectorAll && node.querySelectorAll('button[name="checkout"]').forEach(function (b) {
          candidates.push(b);
        });
        candidates.forEach(function (btn) {
          if (btn.getAttribute('data-kn-drop-time')) {
            initCartDropLock();
          } else {
            tryLockDynamicCheckoutButton(btn);
          }
        });

        // New product drop notice (quick view modal / variant section swap)
        var hasNewNotice = (node.matches && node.matches('.kn-product-drop-notice[data-kn-drop-time]')) ||
                           (node.querySelectorAll && node.querySelectorAll('.kn-product-drop-notice[data-kn-drop-time]').length > 0);
        if (hasNewNotice) scheduleProductDropNotice();

        // Drop badge replaced after variant change (section rendering API)
        var hasNewDropBadge = (node.matches && node.matches('.kn-drop-product-badge')) ||
                              (node.querySelectorAll && node.querySelectorAll('.kn-drop-product-badge').length > 0);
        if (hasNewDropBadge) scheduleProductDropBadges();

        var hasNewBanner = (node.matches && node.matches('.kn-cart-drop-banner')) ||
                           (node.querySelectorAll && node.querySelectorAll('.kn-cart-drop-banner').length > 0);
        if (hasNewBanner) initCartDropBanner();

        // New [data-kn-drop-time] spans arrived from AJAX popup content
        // after the checkout button was already in the DOM. Re-try any
        // unlocked checkout buttons now that drop time is known.
        var hasNewDropTime = (node.matches && node.matches('[data-kn-drop-time]')) ||
                             (node.querySelectorAll && node.querySelectorAll('[data-kn-drop-time]').length > 0);
        if (hasNewDropTime) {
          document.querySelectorAll('button[name="checkout"]').forEach(function (b) {
            if (!b._knTimer) tryLockDynamicCheckoutButton(b);
          });
        }
      });
    });
  });

  window._knDOMObserver.observe(document.body, { childList: true, subtree: true });
}

// ------------------------------------------------------------------
// Watchdog
// Polls while buttons are locked. Catches the timing gap where
// update-nodes fires before bundle.js has swapped the DOM nodes —
// one tick later the DOM is fresh and the scan correctly returns 0.
// ------------------------------------------------------------------

var knWatchdog = null;

function forceUnlockAll() {
  document.querySelectorAll('button[data-kn-locked]').forEach(function (btn) {
    if (btn._knTimer) { clearInterval(btn._knTimer); btn._knTimer = null; }
    if (btn._knObserver) { btn._knObserver.disconnect(); btn._knObserver = null; }
    btn.disabled = false;
    btn.removeAttribute('data-kn-locked');
    setRedoToggle(btn, false);
    if (btn._knNotice) btn._knNotice.style.display = 'none';
  });
  document.querySelectorAll('.kn-cart-drop-notice').forEach(function (el) {
    el.style.display = 'none';
  });
  document.querySelectorAll('.kn-cart-drop-banner').forEach(function (el) {
    el.classList.remove('kn-cart-drop-banner--visible');
    if (el._knBannerTimer) { clearTimeout(el._knBannerTimer); el._knBannerTimer = null; }
  });
}

function startWatchdog() {
  if (knWatchdog) return;
  knWatchdog = setInterval(function () {
    if (!document.querySelectorAll('button[data-kn-locked]').length) {
      clearInterval(knWatchdog); knWatchdog = null;
      return;
    }
    // DOM-only scan — ignores any cached values so stale state
    // can never prevent an unlock after a drop item is removed.
    var maxTime = 0;
    document.querySelectorAll('[data-kn-drop-time]').forEach(function (el) {
      var t = new Date(el.getAttribute('data-kn-drop-time')).getTime();
      if (!isNaN(t) && t > maxTime) maxTime = t;
    });
    if (!maxTime || Date.now() >= maxTime) {
      forceUnlockAll();
      clearInterval(knWatchdog); knWatchdog = null;
    }
  }, 1000);
}

// ------------------------------------------------------------------
// Drop badge lifecycle (shared by product page, product cards, cart)
//
//   before launch ............ show the pre-launch label
//   launch -> launch + Nhrs ... show the "New" label (if enabled)
//   after that ............... hidden
//
// When the "New" window is disabled, behaviour matches the original
// cart badge: hide at launch (if KN_BADGE_HIDE_ELAPSED) or stay on.
// ------------------------------------------------------------------

function dropBadgePhase(dropTime) {
  // No launch time set — always show the pre-launch label.
  if (isNaN(dropTime)) return { phase: 'pre', until: 0 };

  var now = Date.now();
  if (now < dropTime) return { phase: 'pre', until: dropTime };

  if (KN_NEW_ENABLED && KN_NEW_HOURS > 0) {
    var end = dropTime + (KN_NEW_HOURS * 3600000);
    if (now < end) return { phase: 'new', until: end };
    return { phase: 'hidden', until: 0 };
  }

  if (KN_BADGE_HIDE_ELAPSED) return { phase: 'hidden', until: 0 };
  return { phase: 'pre', until: 0 };
}

// setTimeout maxes out around 24.8 days; cap to stay safe.
function scheduleBadge(badge, ms, fn) {
  var delay = Math.min(Math.max(ms, 0) + 50, 2147483647);
  badge._knBadgeTimer = setTimeout(fn, delay);
}

// Cart line-item badges. Badges start hidden (CSS display:none) and
// are revealed after the phase is known to avoid a flash-of-content.
function initDropBadges() {
  document.querySelectorAll('cart-item').forEach(function (cartItem) {
    var badges = cartItem.querySelectorAll('.kn-drop-badge');
    if (!badges.length) return;

    var dropAttr = cartItem.getAttribute('data-kn-drop-time');
    var dropTime = dropAttr ? new Date(dropAttr).getTime() : NaN;

    badges.forEach(function (badge) {
      if (!badge._knPreLabel) badge._knPreLabel = (badge.textContent || '').trim();

      function render() {
        if (badge._knBadgeTimer) { clearTimeout(badge._knBadgeTimer); badge._knBadgeTimer = null; }
        var p = dropBadgePhase(dropTime);
        if (p.phase === 'pre') {
          badge.textContent = badge._knPreLabel;
          badge.classList.add('kn-drop-badge--visible');
        } else if (p.phase === 'new') {
          badge.textContent = KN_NEW_LABEL;
          badge.classList.add('kn-drop-badge--visible');
        } else {
          badge.classList.remove('kn-drop-badge--visible');
        }
        if (p.until > 0) scheduleBadge(badge, p.until - Date.now(), render);
      }
      render();
    });
  });
}

// Cart banner above the item list. Hidden by default (CSS) and only
// revealed while checkout is still locked — same moment the badges
// flip from the pre-launch label to "New".
function initCartDropBanner() {
  document.querySelectorAll('.kn-cart-drop-banner').forEach(function (banner) {
    var dropAttr = banner.getAttribute('data-kn-drop-time');
    var dropTime = dropAttr ? new Date(dropAttr).getTime() : NaN;

    function render() {
      if (banner._knBannerTimer) { clearTimeout(banner._knBannerTimer); banner._knBannerTimer = null; }
      if (!isNaN(dropTime) && Date.now() < dropTime) {
        banner.classList.add('kn-cart-drop-banner--visible');
        knLog('Cart drop banner shown until', new Date(dropTime).toISOString());
        var delay = Math.min(Math.max(dropTime - Date.now(), 0) + 50, 2147483647);
        banner._knBannerTimer = setTimeout(render, delay);
      } else {
        banner.classList.remove('kn-cart-drop-banner--visible');
        knLog('Cart drop banner hidden — drop time passed or missing', dropAttr);
      }
    }
    render();
  });
}

// Product page + product card badges (.kn-drop-product-badge).
// Drop time and pre-launch label live on each badge element.
function initProductDropBadges() {
  document.querySelectorAll('.kn-drop-product-badge').forEach(function (badge) {
    var dropAttr = badge.getAttribute('data-kn-drop-time');
    var dropTime = dropAttr ? new Date(dropAttr).getTime() : NaN;
    var textEl = badge.querySelector('.kn-drop-product-badge__text') || badge;
    var preLabel = badge.getAttribute('data-kn-drop-label') || '';

    function render() {
      if (badge._knBadgeTimer) { clearTimeout(badge._knBadgeTimer); badge._knBadgeTimer = null; }
      var p = dropBadgePhase(dropTime);
      if (p.phase === 'pre') {
        textEl.textContent = preLabel;
        badge.classList.add('kn-drop-product-badge--visible');
      } else if (p.phase === 'new') {
        textEl.textContent = KN_NEW_LABEL;
        badge.classList.add('kn-drop-product-badge--visible');
      } else {
        badge.classList.remove('kn-drop-product-badge--visible');
      }
      if (p.until > 0) scheduleBadge(badge, p.until - Date.now(), render);
    }
    render();
  });
}

// Aurora re-renders [data-product-block] nodes via the Section Rendering
// API on every variant change, which replaces the badge with fresh HTML
// (hidden, no timers). Debounce re-inits so we catch the swapped nodes.
var knBadgeReinitTimer = null;
var knDropNoticeReinitTimer = null;

function scheduleProductDropBadges() {
  if (knBadgeReinitTimer) clearTimeout(knBadgeReinitTimer);
  knBadgeReinitTimer = setTimeout(function () {
    knBadgeReinitTimer = null;
    initProductDropBadges();
  }, 50);
}

function scheduleProductDropNotice() {
  if (knDropNoticeReinitTimer) clearTimeout(knDropNoticeReinitTimer);
  knDropNoticeReinitTimer = setTimeout(function () {
    knDropNoticeReinitTimer = null;
    initProductDropNotice();
  }, 50);
}

// variant-picker fires change -> fetch section HTML -> swap blocks.
function installVariantBlockRefresh() {
  document.addEventListener('change', function (e) {
    if (!e.target.closest || !e.target.closest('variant-picker')) return;
    scheduleProductDropBadges();
    scheduleProductDropNotice();
  }, true);
}

// ------------------------------------------------------------------
// Main init
// ------------------------------------------------------------------

function init() {
  installFormIntercept();
  installDOMObserver();
  installVariantBlockRefresh();
  initProductDropNotice();
  initCartDropLock();
  initCartDropBanner();
  initDropBadges();
  initProductDropBadges();
  initSoldOutPillNotify();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}

// Re-run after AJAX cart updates.
// Watchdog handles cleanup if a drop item was removed.
document.addEventListener('update-nodes', function () {
  initCartDropLock();
  initCartDropBanner();
  initDropBadges();
  scheduleProductDropBadges();
});
})();
